import { GetServerSideProps } from 'next'

import CardLists from '@/components/CardLists/CardLists'
import Container from '@/components/Container/Container'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import RelatedInfo from '@/components/RelatedInfo/RelatedInfo'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import SubMenu from '@/components/SubMenu/SubMenu'
import Tabs from '@/components/Tabs/Tabs'
import { TagsPageProps } from '@/types/page'
import { COLORS } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'
import useDirectories from '@/utils/useDirectories'

const getSubmenuItems = (subpage: string) => {
  const color = Object.values(COLORS)
    .map((color) => color.toLowerCase())
    .includes(subpage?.toLowerCase())
    ? subpage
    : undefined
  const suffix = color ? `/${color}` : ''
  return [
    { name: 'All', url: `/tags${suffix}` },
    { name: 'Kindred', url: `/tags/kindred${suffix}` },
    { name: 'Themes', url: `/tags/themes${suffix}` },
  ]
}

const TagsPage = ({ data }: TagsPageProps) => {
  const { subpage, subsubpage } = useDirectories()

  const submenuItems = getSubmenuItems(subsubpage || subpage)

  return (
    <Main>
      <DefaultHead data={data} />
      <Container>
        <SimpleHeader>{data.header}</SimpleHeader>
        <RelatedInfo
          dropdowns
          relatedInfo={data.related_info}
          subpage={subpage}
          subsubpage={subsubpage}
          textRightSuffix='decks'
        />
      </Container>
      <Tabs>
        <SubMenu items={submenuItems} />
      </Tabs>
      <CardLists
        initCardLists={data.container.json_dict.cardlists}
        showSearch={[undefined, 'kindred', 'themes'].includes(subpage)}
      />
    </Main>
  )
}

export const getServerSideProps: GetServerSideProps<TagsPageProps> = async ({ req }) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/tags.json`, req.headers)

export default TagsPage
